import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Router from "..";

export const useSocialData = (social, socialInfluencerId) => {
  return useQuery({
    queryKey: ["socialData", social, socialInfluencerId],
    queryFn: async () => {
      const data = await Router.Api.getSocialInfo(social, socialInfluencerId);

      if (!data) {
        return null;
      }
      return data;
    },
    enabled: !!socialInfluencerId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useAddCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ categories, social }) =>
      Router.Api.addCategory(categories, social),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["socialData", variables.social],
      });
    },
  });
};

export const useDeleteCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ categories, social }) =>
      Router.Api.deleteCategory(categories, social),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["socialData", variables.social],
      });
    },
  });
};
